import { numberToPrettyString } from '@cian/utils';

export function rangeDistanceStr(prefix: string, gte: number = 0, lte: number = 0) {
  const gteStr = ` более ${numberToPrettyString(gte)}`;
  const lteStr = ` не более ${numberToPrettyString(lte)}`;

  return `${prefix}${gte ? gteStr : ''}${lte ? lteStr : ''} км`;
}
